import { Button, FormControl, TextField } from '@mui/material';
import styled from 'styled-components';

// @TODO~>cwd: consolidate with existing Modal stuff
export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`;

export const ModalForm = styled.form`
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`;

export const ModalButton = styled(Button)`
    margin-left: 0.5rem;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const StyledTextField = styled(TextField)`
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledFormControl = styled(FormControl)`
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
        margin-right: 4px;
    }
`;
